
import Vue from 'vue'

const locales = {keys(){return []}}
global['____75114E0____'] = true;
delete global['____75114E0____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"智慧食堂","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"},"tabBar":{"color":"#919293","selectedColor":"##007aff","backgroundColor":"#fff","borderStyle":"black","list":[{"pagePath":"pages/menu/menu","text":"首页","iconPath":"static/images/tabBar/drink.png","selectedIconPath":"static/images/tabBar/drink_selected.png","redDot":false,"badge":""},{"pagePath":"pages/orders/orders","text":"订单","iconPath":"static/images/tabBar/order.png","selectedIconPath":"static/images/tabBar/order_selected.png","redDot":false,"badge":""},{"pagePath":"pages/qr/qr","text":"取餐","iconPath":"static/images/tabBar/qucan.png","selectedIconPath":"static/images/tabBar/qucan_select.png","redDot":false,"badge":""},{"pagePath":"pages/mine/mine","text":"我的","iconPath":"static/images/tabBar/mine.png","selectedIconPath":"static/images/tabBar/mine_selected.png","redDot":false,"badge":""}]}};
global.__uniConfig.compilerVersion = '4.36';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__75114E0';
global.__uniConfig.appName = '订餐';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"history","base":"/"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "zh-Hans";
global.__uniConfig.fallbackLocale = "en";
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-menu-menu', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/menu/menu"+'.vue')), 'pages-menu-menu'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-menu-menu', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/menu/menu"+'.vue')), 'pages-menu-menu'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-take-foods-take-foods', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/take-foods/take-foods"+'.vue')), 'pages-take-foods-take-foods'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-mine', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/mine/mine"+'.vue')), 'pages-mine-mine'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-pay-pay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/pay/pay"+'.vue')), 'pages-pay-pay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-remark-remark', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/remark/remark"+'.vue')), 'pages-remark-remark'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-packages-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/packages/index"+'.vue')), 'pages-packages-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-packages-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/packages/detail"+'.vue')), 'pages-packages-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-balance-balance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/balance/balance"+'.vue')), 'pages-balance-balance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/login/login"+'.vue')), 'pages-login-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/address/address"+'.vue')), 'pages-address-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-address-add', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/address/add"+'.vue')), 'pages-address-add'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-integrals-integrals', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/integrals/integrals"+'.vue')), 'pages-integrals-integrals'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-attendance-attendance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/attendance/attendance"+'.vue')), 'pages-attendance-attendance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-orders-orders', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/orders/orders"+'.vue')), 'pages-orders-orders'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-orders-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/orders/detail"+'.vue')), 'pages-orders-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-member-code', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/mine/member-code"+'.vue')), 'pages-mine-member-code'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-coupons-coupons', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/coupons/coupons"+'.vue')), 'pages-coupons-coupons'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-mine-userinfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/mine/userinfo"+'.vue')), 'pages-mine-userinfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-integrals-flow', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/integrals/flow"+'.vue')), 'pages-integrals-flow'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-integrals-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/integrals/detail"+'.vue')), 'pages-integrals-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-review-review', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/review/review"+'.vue')), 'pages-review-review'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-activities-invite', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/activities/invite"+'.vue')), 'pages-activities-invite'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-services-services', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/services/services"+'.vue')), 'pages-services-services'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-invoice-invoice', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/invoice/invoice"+'.vue')), 'pages-invoice-invoice'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-services-help-center', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/services/help-center"+'.vue')), 'pages-services-help-center'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-giftcard-giftcard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/giftcard/giftcard"+'.vue')), 'pages-giftcard-giftcard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-feedbackIndex-feedbackIndex', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/feedbackIndex/feedbackIndex"+'.vue')), 'pages-common-feedbackIndex-feedbackIndex'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-feedbackList-feedbackList', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/feedbackList/feedbackList"+'.vue')), 'pages-common-feedbackList-feedbackList'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-feedback-feedback', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/feedback/feedback"+'.vue')), 'pages-common-feedback-feedback'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-helpDetail-helpDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/helpDetail/helpDetail"+'.vue')), 'pages-common-helpDetail-helpDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-feedbackDetail-feedbackDetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/feedbackDetail/feedbackDetail"+'.vue')), 'pages-common-feedbackDetail-feedbackDetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-common-showImage-showImage', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/common/showImage/showImage"+'.vue')), 'pages-common-showImage-showImage'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-qr-qr', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/qr/qr"+'.vue')), 'pages-qr-qr'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-receipt-receipt', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/receipt/receipt"+'.vue')), 'pages-receipt-receipt'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-menu-menu-advance', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/menu/menu-advance"+'.vue')), 'pages-menu-menu-advance'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-user-management-user-management', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/user-management/user-management"+'.vue')), 'pages-user-management-user-management'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-meal-time-meal-time', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/meal-time/meal-time"+'.vue')), 'pages-meal-time-meal-time'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-order-details-order-details', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/order-details/order-details"+'.vue')), 'pages-order-details-order-details'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-report-statistics-report-statistics', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/report-statistics/report-statistics"+'.vue')), 'pages-report-statistics-report-statistics'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-dashboard-dashboard', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("/Users/east/appWork/rest-front/pages/dashboard/dashboard"+'.vue')), 'pages-dashboard-dashboard'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/menu/menu',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-menu-menu', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-menu-menu',
  isNVue:false,maxWidth:0,
  pagePath:'pages/menu/menu',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:0
}
},
{
path: '/',
alias:'/pages/menu/menu',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,
isTabBar:true,

          
          tabBarIndex:0
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-menu-menu', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:2,
  name:'pages-menu-menu',
  isNVue:false,maxWidth:0,
  pagePath:'pages/menu/menu',
isQuit:true,
isEntry:true,
isTabBar:true,
tabBarIndex:0,
  windowTop:44
}
},
{
path: '/pages/take-foods/take-foods',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-take-foods-take-foods', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-take-foods-take-foods',
  isNVue:false,maxWidth:0,
  pagePath:'pages/take-foods/take-foods',
  windowTop:44
}
},
{
path: '/pages/mine/mine',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:3
        },__uniConfig.globalStyle,{"navigationBarTitleText":"个人中心","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-mine-mine', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:3,
  name:'pages-mine-mine',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/mine',
isQuit:true,
isTabBar:true,
tabBarIndex:3,
  windowTop:44
}
},
{
path: '/pages/pay/pay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-pay-pay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-pay-pay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/pay/pay',
  windowTop:44
}
},
{
path: '/pages/remark/remark',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-remark-remark', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-remark-remark',
  isNVue:false,maxWidth:0,
  pagePath:'pages/remark/remark',
  windowTop:44
}
},
{
path: '/pages/packages/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"券包商品","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","enablePullDownRefresh":true})
      },
      [
        createElement('pages-packages-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-packages-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/packages/index',
  windowTop:44
}
},
{
path: '/pages/packages/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"购买劵包","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","enablePullDownRefresh":true})
      },
      [
        createElement('pages-packages-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-packages-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/packages/detail',
  windowTop:44
}
},
{
path: '/pages/balance/balance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员储值","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-balance-balance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-balance-balance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/balance/balance',
  windowTop:44
}
},
{
path: '/pages/login/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-login-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/login',
  windowTop:44
}
},
{
path: '/pages/address/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的地址","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-address-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/address',
  windowTop:44
}
},
{
path: '/pages/address/add',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-address-add', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-address-add',
  isNVue:false,maxWidth:0,
  pagePath:'pages/address/add',
  windowTop:44
}
},
{
path: '/pages/integrals/integrals',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","onReachBottomDistance":50})
      },
      [
        createElement('pages-integrals-integrals', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-integrals-integrals',
  isNVue:false,maxWidth:0,
  pagePath:'pages/integrals/integrals',
  windowTop:0
}
},
{
path: '/pages/attendance/attendance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-attendance-attendance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-attendance-attendance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/attendance/attendance',
  windowTop:0
}
},
{
path: '/pages/orders/orders',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:1
        },__uniConfig.globalStyle,{"navigationBarTitleText":"历史订单","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","enablePullDownRefresh":true,"onReachBottomDistance":50})
      },
      [
        createElement('pages-orders-orders', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:4,
  name:'pages-orders-orders',
  isNVue:false,maxWidth:0,
  pagePath:'pages/orders/orders',
isQuit:true,
isTabBar:true,
tabBarIndex:1,
  windowTop:44
}
},
{
path: '/pages/orders/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订单详情","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-orders-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-orders-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/orders/detail',
  windowTop:44
}
},
{
path: '/pages/mine/member-code',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"会员码","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-mine-member-code', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-member-code',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/member-code',
  windowTop:44
}
},
{
path: '/pages/coupons/coupons',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"我的卡券","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-coupons-coupons', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-coupons-coupons',
  isNVue:false,maxWidth:0,
  pagePath:'pages/coupons/coupons',
  windowTop:44
}
},
{
path: '/pages/mine/userinfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户信息","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-mine-userinfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-mine-userinfo',
  isNVue:false,maxWidth:0,
  pagePath:'pages/mine/userinfo',
  windowTop:44
}
},
{
path: '/pages/integrals/flow',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"积分明细","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-integrals-flow', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-integrals-flow',
  isNVue:false,maxWidth:0,
  pagePath:'pages/integrals/flow',
  windowTop:44
}
},
{
path: '/pages/integrals/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"兑换详情","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-integrals-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-integrals-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/integrals/detail',
  windowTop:44
}
},
{
path: '/pages/review/review',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-review-review', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-review-review',
  isNVue:false,maxWidth:0,
  pagePath:'pages/review/review',
  windowTop:44
}
},
{
path: '/pages/activities/invite',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-activities-invite', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-activities-invite',
  isNVue:false,maxWidth:0,
  pagePath:'pages/activities/invite',
  windowTop:44
}
},
{
path: '/pages/services/services',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-services-services', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-services-services',
  isNVue:false,maxWidth:0,
  pagePath:'pages/services/services',
  windowTop:44
}
},
{
path: '/pages/invoice/invoice',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"智慧食堂","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-invoice-invoice', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-invoice-invoice',
  isNVue:false,maxWidth:0,
  pagePath:'pages/invoice/invoice',
  windowTop:44
}
},
{
path: '/pages/services/help-center',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"帮助中心","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-services-help-center', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-services-help-center',
  isNVue:false,maxWidth:0,
  pagePath:'pages/services/help-center',
  windowTop:44
}
},
{
path: '/pages/giftcard/giftcard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"礼品卡列表","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff","disableScroll":true})
      },
      [
        createElement('pages-giftcard-giftcard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-giftcard-giftcard',
  isNVue:false,maxWidth:0,
  pagePath:'pages/giftcard/giftcard',
  windowTop:44
}
},
{
path: '/pages/common/feedbackIndex/feedbackIndex',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"意见反馈","enablePullDownRefresh":false})
      },
      [
        createElement('pages-common-feedbackIndex-feedbackIndex', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-feedbackIndex-feedbackIndex',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/feedbackIndex/feedbackIndex',
  windowTop:44
}
},
{
path: '/pages/common/feedbackList/feedbackList',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"意见反馈","enablePullDownRefresh":false})
      },
      [
        createElement('pages-common-feedbackList-feedbackList', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-feedbackList-feedbackList',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/feedbackList/feedbackList',
  windowTop:44
}
},
{
path: '/pages/common/feedback/feedback',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"意见反馈","enablePullDownRefresh":false,"backgroundColor":"#FFFFFF"})
      },
      [
        createElement('pages-common-feedback-feedback', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-feedback-feedback',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/feedback/feedback',
  windowTop:44
}
},
{
path: '/pages/common/helpDetail/helpDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"帮助详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-common-helpDetail-helpDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-helpDetail-helpDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/helpDetail/helpDetail',
  windowTop:44
}
},
{
path: '/pages/common/feedbackDetail/feedbackDetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"反馈详情","enablePullDownRefresh":false})
      },
      [
        createElement('pages-common-feedbackDetail-feedbackDetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-feedbackDetail-feedbackDetail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/feedbackDetail/feedbackDetail',
  windowTop:44
}
},
{
path: '/pages/common/showImage/showImage',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"图片预览","enablePullDownRefresh":false,"navigationBarTextStyle":"white","navigationBarBackgroundColor":"#000000"})
      },
      [
        createElement('pages-common-showImage-showImage', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-common-showImage-showImage',
  isNVue:false,maxWidth:0,
  pagePath:'pages/common/showImage/showImage',
  windowTop:44
}
},
{
path: '/pages/qr/qr',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isTabBar:true,

          
          tabBarIndex:2
        },__uniConfig.globalStyle,{"navigationBarTitleText":"取餐码","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-qr-qr', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:5,
  name:'pages-qr-qr',
  isNVue:false,maxWidth:0,
  pagePath:'pages/qr/qr',
isQuit:true,
isTabBar:true,
tabBarIndex:2,
  windowTop:44
}
},
{
path: '/pages/receipt/receipt',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('pages-receipt-receipt', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-receipt-receipt',
  isNVue:false,maxWidth:0,
  pagePath:'pages/receipt/receipt',
  windowTop:44
}
},
{
path: '/pages/menu/menu-advance',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"预定餐品","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-menu-menu-advance', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-menu-menu-advance',
  isNVue:false,maxWidth:0,
  pagePath:'pages/menu/menu-advance',
  windowTop:44
}
},
{
path: '/pages/user-management/user-management',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用户管理","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-user-management-user-management', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-user-management-user-management',
  isNVue:false,maxWidth:0,
  pagePath:'pages/user-management/user-management',
  windowTop:44
}
},
{
path: '/pages/meal-time/meal-time',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"用餐时段管理","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-meal-time-meal-time', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-meal-time-meal-time',
  isNVue:false,maxWidth:0,
  pagePath:'pages/meal-time/meal-time',
  windowTop:44
}
},
{
path: '/pages/order-details/order-details',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"订餐明细","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-order-details-order-details', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-order-details-order-details',
  isNVue:false,maxWidth:0,
  pagePath:'pages/order-details/order-details',
  windowTop:44
}
},
{
path: '/pages/report-statistics/report-statistics',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"报餐统计","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-report-statistics-report-statistics', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-report-statistics-report-statistics',
  isNVue:false,maxWidth:0,
  pagePath:'pages/report-statistics/report-statistics',
  windowTop:44
}
},
{
path: '/pages/dashboard/dashboard',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"后台管理首页","navigationBarTextStyle":"black","navigationBarBackgroundColor":"#ffffff"})
      },
      [
        createElement('pages-dashboard-dashboard', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-dashboard-dashboard',
  isNVue:false,maxWidth:0,
  pagePath:'pages/dashboard/dashboard',
  windowTop:44
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
